import { type Amount } from '../../../common/amount'
import { mergeClassName } from '../../../utils/mergeClassName'
import { useGetQuoteJobPrice, type Quote } from '../../../modules/quotes'
import { applyPromoCode } from '../../../modules/promoCodes'
import { useQuoteContext } from '../QuoteComponent.context'
import AlternativeDate from './AlternativeDate'
import DateBox from './DateBox'

type AlternativeDatesProps = {
  quote: Quote
  jobIndex: number
  className?: string
}

const AlternativeDates: React.FC<AlternativeDatesProps> = ({
  quote,
  jobIndex,
  className,
}) => {
  const job = quote.jobs[jobIndex]
  const { promoCode } = useQuoteContext()
  const { discount } = useGetQuoteJobPrice()(quote, jobIndex, { promoCode })

  const getSubtotalWithPromoCode = (amount: Amount) => {
    return discount ? applyPromoCode(amount, promoCode) : amount
  }

  if (!job) {
    return null
  }

  const alternativeDates = job.alternativeDates
  if (!alternativeDates?.length) {
    return null
  }

  const before = alternativeDates.filter(date => new Date(date.date) < new Date(job.date))
  const after = alternativeDates.filter(date => new Date(date.date) > new Date(job.date))

  return (
    <div className={mergeClassName(
      'flex flex-wrap gap-[5px] justify-center sm:justify-normal',
      className,
    )}
    >
      { before.map(alternativeDate => (
        <AlternativeDate
          key={new Date(alternativeDate.date).getTime()}
          alternativeDate={alternativeDate}
          job={job}
          promoCode={discount ? promoCode : undefined}
        />
      )) }

      <DateBox
        current
        date={new Date(job.date)}
        price={getSubtotalWithPromoCode(job.subtotal)}
      />

      { after.map(alternativeDate => (
        <AlternativeDate
          key={new Date(alternativeDate.date).getTime()}
          alternativeDate={alternativeDate}
          job={job}
          promoCode={discount ? promoCode : undefined}
        />
      )) }

    </div>
  )
}

export default AlternativeDates
